<template>
  <div class="wrapper" :class="{'menu-open' : mobileOpen}">
    <div class="dashboard" :class="sidebar">
      <div class="header">
        <img alt="logo" src="./../assets/img/logo.svg" class="logo" @click="goHome">
        <button class="close-menu-btn btn-icon" @click="closeMobileMenu"><i class="icon-close"></i></button>
      </div>
      <div class="dashboard-menu">
        <div class="menu-item transparent">
          <div class="dashboard-title mobile-hidden">{{$lang.messages.parent_dashboard.title}}<span class="nowrap">&nbsp;</span>
            <span v-tooltip="$lang.messages.parent_dashboard.tooltip" class="info-icon question"></span>
          </div>
          <div class="dashboard-subtitle">{{$lang.messages.parent_dashboard.welcome}}</div>
        </div>
        <Menu
            v-for="(component) in menu"
            v-bind="component"
            :showtext="sidebar"
            :currentab="currentTab"
            :key="component.key"
            :showActive="siteSectionOpen"
            v-on:openmenuitem="openmenuitem"
        />
        <div class="switch-mode-block mt-3 mobile-hidden">
          <button class="btn btn-switch-mode" :disabled="switchModeDisabled" @click.prevent="toggleKidsMode" >
            <i class="icon-lock"></i>
            {{ extIsSetUp ? $lang.messages.parent_dashboard.switch_mode_btn : settings && settings.kidsMode ? 'Kids mode is on' : 'Kids mode is off'}}
          </button>
        </div>
        <div v-if="!user.email" class="flex-v-center flex-between desktop-hidden mt-2 w-100">
          <span class="header-text">{{$lang.messages.for_more}} {{$lang.messages.functionality}}</span>
          <a href="#" class="btn btn-main" @click.prevent="showMessageInLogin = false; showLoginModal = true">{{$lang.messages.sign_in}}</a>
        </div>
        <div v-if="user.email" class="flex-v-center flex-wrap desktop-hidden mt-2" >
          <span class="header-text text-bold" @click="mobileOpen = false; accountOpen = true">{{ user.email }}</span>
          <a href="#" class="btn btn-secondary" @click.prevent="signOut">{{$lang.messages.sign_out}}</a>
        </div>
      </div>
    </div>
    <div class="content">
      <Subscription v-if="accountOpen"
                    v-on:updatesettings="savesettings"
                    v-on:closesubsmodal="accountOpen = false"
                    v-on:getpremium="getPremium"
                    v-bind="currentProperties" :userEmail="user.email"/>
      <div class="header" :class="{ 'header-android': isAndroid, 'for-dashboard': sidebar === 'wide', 'for-mobile': sidebar === 'narrow' && settings && settings.isPremium, 'no-premium': settings && !settings.isPremium }">
        <span class="desktop-hidden pointer" v-if="isAndroid && !siteSectionOpen" @click="goBackAndroid">
          <svg width="22" height="22" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.41421 8.5L8.70711 12.7929L7.29289 14.2071L0.585786 7.5L7.29289 0.792893L8.70711 2.20711L4.41421 6.5H13V8.5H4.41421Z" fill="#806DEF"/>
          </svg>
        </span>
        <img v-if="!siteSectionOpen" alt="logo" src="./../assets/img/logo.svg" class="logo desktop-hidden" @click="goHome">
        <span v-if="siteSectionOpen" class="back-btn desktop-hidden" @click="goHome">{{ $lang.messages.back }}</span>
        <span class="burger desktop-hidden" @click="mobileOpen = !mobileOpen"><span class="burger-btn"></span></span>
        <div v-if="sidebar === 'narrow' && settings && !settings.isPremium"
             class="premium-banner -header mobile-hidden"
             @click="clickBanner"
        >
          <img alt="premium" width="670" height="65" src="./../assets/img/premium-header.svg">
          <button class="btn btn-premium">{{$lang.messages.get_premium}}</button>
        </div>
        <span v-if="!siteSectionOpen" class="kid-status mobile-hidden" :class="{ active: settings && settings.kidsMode }">
            <strong>{{settings && settings.kidName != '' ? settings.kidName : 'Kid'}}'s </strong>
            &nbsp;now {{settings && settings.kidsMode ? 'active' : 'inactive'}}
          </span>
        <div v-if="!user.email" class="flex-v-center mobile-hidden">
          <span class="header-text" v-if="sidebar === 'narrow'">{{$lang.messages.for_more}} <br> {{$lang.messages.functionality}}</span>
          <a href="#" class="btn btn-main" @click.prevent="showMessageInLogin = false; showLoginModal = true">{{$lang.messages.sign_in}}</a>
        </div>
        <div v-if="user.email" class="header-login flex-v-center mobile-hidden">
          <span class="header-text text-bold pointer account-settings" @click="accountOpen = true">{{ user.email }}</span>
          <a href="#" class="btn btn-main" @click.prevent="signOut"><span class="text-normal">{{$lang.messages.sign_out}}</span></a>
        </div>
      </div>
      <component
          :is="currentTabComponent"
          v-bind="currentProperties"
          :stat="currentStat"
          v-on:updatesettings="savesettings"
          v-on:showloginmodal="showMessageInLogin = false; showLoginModal = true"
          v-on:showpremiummodal="getPremium"
          v-on:openmenuitem="openmenuitem"
          v-on:removetoomuchlinks="tooMuchLinks = false"
          v-on:openonlypremiummodal="showOnlyPremium"
      ></component>
    </div>
    <div v-show="showLoginModal" class="modal" @click.self="showLoginModal = false">
      <div class="modal-dialog modal-dialog-sm">
        <div v-if="showMessageInLogin" class="mt-2 mr-2 ml-2 mb-1 form-error text-center">{{$lang.messages.get_premium_modal.sign_in_before_get_premium}}</div>
        <div id="firebaseui-auth-container"></div>
      </div>
    </div>
    <PremiumPurchasedModal
        :newUser="newUserLogged"
        v-show="showPremiumIsPurchased"
        v-on:closemodal="showPremiumIsPurchased = false"/>
    <GetPremiumModal v-if="showGetPremium"
                     :customer="currentProperties.customer"
                     v-on:closepremiummodal="showGetPremium = false"
                     v-on:premiumispurchased="showPremiumIsPurchased = true"
                     v-on:updatesettings="savesettings"/>
    <GetPremiumModalAndroid v-if="showGetPremiumAndroid"
                            v-on:closepremiummodal="showGetPremiumAndroid = false" />
      <div class="footer desktop-hidden">
        <img alt="logo" src="./../assets/img/logo.svg" class="logo" @click="goHome">
        <div class="footer-menu">
          <Menu
              v-for="(component) in menu"
              v-bind="component"
              :showtext="sidebar"
              :currentab="currentTab"
              :showActive="siteSectionOpen"
              :key="component.key"
              v-on:openmenuitem="openmenuitem"
          />
        </div>
      </div>
    <PremiumModal v-if="showOnlyPremiumModal"
                  v-on:openmenuitem="openmenuitem"
                  v-on:closepremiummodal="showOnlyPremiumModal = false"
                  v-on:showpremiummodal="getPremium"/>
    <Help :videoIsOpen="showTutorialVideo"/>
    <Feedback/>
  </div>
</template>
<script>
import Menu from '../components/Menu.vue'
import Settings from '../components/Settings.vue'
import Sites from '../components/Sites.vue'
import Backgrounds from '../components/Themes.vue'
import Statistics from '../components/Statistics.vue'
import Remote from '../components/Remote.vue'
import Premium from '../components/Premium.vue'
import PremiumModal from '../components/PremiumModal.vue'
import Subscription from '../components/Subscription.vue'
import {connectToExtension, getTimeStamp, reportEvent, sendRegistrationEmail, getCookie, hitFCMessage} from '../helpers/utils'

import firebase from 'firebase/app'
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'

import { db } from '../fb/firebase'
import { defaultUserSettings, defaultUserStatistic } from '../helpers/configs'
import GetPremiumModal from "@/components/GetPremiumModal";
import GetPremiumModalAndroid from "@/components/GetPremiumModalAndroid";
import PremiumPurchasedModal from "@/components/PremiumPurchasedModal";
import Help from "@/components/Help"
import {API_HOST} from "@/helpers/stipe_const";
import Feedback from "@/components/Feedback";
export default {
  name: 'Parent',
  data: function () {
    return {
      user: {
        uid: null,
        email: null
      },
      extIsSetUp: !JSON.parse(localStorage.getItem('isRemote')),
      settings: defaultUserSettings,
      statistic: defaultUserStatistic,
      sidebar: 'wide',
      siteSectionOpen: false,
      currentTab: "Statistics",
      showLoginModal: false,
      mobileOpen: false,
      showGetPremium: false,
      showGetPremiumAndroid: false,
      showPremiumIsPurchased: false,
      tooMuchLinks: false,
      showMessageInLogin: false,
      showOnlyPremiumModal: false,
      switchModeDisabled: false,
      newUserLogged: false,
      accountOpen: false,
      isAndroid: window.Android,
      menu: [
        {
          key: 1,
          titleID: 'Settings',
          title: this.$lang.messages.menu.settings.title,
          text: this.$lang.messages.menu.settings.description,
          icon: 'settings.svg'
        },
        {
          key: 2,
          titleID: 'Sites',
          title: this.$lang.messages.menu.sites.title,
          text: this.$lang.messages.menu.sites.description,
          icon: 'sites.svg'
        },
        {
          key: 3,
          titleID: 'Backgrounds',
          title: this.$lang.messages.menu.themes.title,
          text: this.$lang.messages.menu.themes.description,
          icon: 'themes.svg'
        },
        {
          key: 4,
          titleID: 'Statistics',
          title: this.$lang.messages.menu.statistics.title,
          text: this.$lang.messages.menu.statistics.description,
          icon: 'statistic.svg'
        },
        {
          key: 5,
          titleID: 'Remote',
          title: this.$lang.messages.menu.remote.title,
          text: this.$lang.messages.menu.remote.description,
          icon: 'remote.svg'
        }
      ],
      unsubscribeFB: null,
      testPayment: localStorage.getItem('stripeTest'),
    }
  },
  computed: {
    showTutorialVideo: function (){
      return false;
    },
    currentTabComponent: function() {
      return this.currentTab;
    },
    currentStat: function (){
      return this.statistic
    },
    currentProperties: function() {
      return this.settings && {
        user: this.user,
        password: this.settings.password,
        kidname: this.settings.kidName,
        kidage: this.settings.kidAge,
        kidsMode: this.settings.kidsMode,
        unlockMethod: this.settings.unlockMethod,
        isPremium: this.settings.isPremium,
        premiumEnd: this.settings.premiumEnd,
        lockOnStart: this.settings.lockOnStart,
        autoLock: this.settings.autoLock,
        alwaysTop: this.settings.alwaysTop,
        availableTime: this.settings.availableTime,
        dailyLimit: this.settings.dailyLimit,
        todayDailyLimit: this.settings.todayDailyLimit,
        dailyLimitUsed: this.settings.dailyLimitUsed,
        allowKidRequestSite: this.settings.allowKidRequestSite,
        links: this.settings.links || [],
        uploadedThemes: this.settings.uploadedThemes || [],
        userRemovedRecommended: this.settings.userRemovedRecommended || [],
        themeCurrent: this.settings.theme,
        isUnAvailableTime: this.settings.isUnAvailableTime,
        isLocked: this.settings.isUnAvailableTime || this.settings.dailyLimitUsed >= this.settings.todayDailyLimit,
        sidebar: this.sidebar,
        requests: this.settings.requests,
        customer: this.settings.customer,
        tooMuchLinks: this.tooMuchLinks,
        siteSectionOpen: this.siteSectionOpen,
      }
    }
  },
  methods: {
    goBackAndroid(){
      if (window.Android) {
        window.Android.sendJsMsgToBackApp();
      }
    },
    toggleKidsMode () {
      const newKidsModeValue = !this.settings.kidsMode;
      if (newKidsModeValue) {
        reportEvent('enterKidsMode')
      }
      this.savesettings({kidsMode: newKidsModeValue})
      this.switchModeDisabled = true
      setTimeout(() =>  this.switchModeDisabled = false, 1000 )
    },
    getPremium () {
      if(firebase.auth().currentUser.isAnonymous){
        this.showMessageInLogin = true
        this.showLoginModal = true
      } else {
        if (window.Android) {
          this.showGetPremiumAndroid = true
        } else {
          this.showGetPremium = true
        }
        reportEvent('premium_dialog_open')
      }
    },
    showOnlyPremium () {
      this.showOnlyPremiumModal = true
    },
    openmenuitem (title, additionalTabInfo) {
      this.sidebar = 'narrow'
      this.siteSectionOpen = true
      this.mobileOpen = false
      this.showOnlyPremiumModal = false
      this[additionalTabInfo] = true
      this.currentTab = title.split(' ')[0]
      reportEvent('openMenuItem', {'menuSection': title, 'isPremium': this.settings.isPremium, 'isRemote': localStorage.getItem('isRemote')})
    },
    goHome () {
      if(!window.matchMedia('(max-width: 1200px)').matches) {
        this.sidebar = 'wide'
      }
      this.mobileOpen = false
      this.siteSectionOpen = false
      this.currentTab = "Statistics"
      reportEvent('openDashboard', {'isPremium': this.settings.isPremium, 'isRemote': localStorage.getItem('isRemote')})
    },
    savesettings (settings) {
      if (settings.kidsMode) {
        hitFCMessage(this.settings.fcmToken)
      }
      const newsettings = {}
      Object.keys(settings).forEach((item) => {
        newsettings['/'+item] = settings[item]
      })
      db.ref('users/' + this.user.uid).child('settings').update(newsettings).then(() => {
        console.log('user updated!')
      })
    },
    signOut () {
      const query = this.$router.currentRoute.query;
      if (window.Android && this.settings.fcmToken) {
        const filteredTokens = this.settings.fcmToken.filter(token => token !== query.token)
        this.savesettings({
          fcmToken: filteredTokens
        })
      }
      firebase.auth().signOut()
      reportEvent('userSignOut')
    },
    updateUserInfo(user) {
      if (user) {
        if (!user.isAnonymous) {
          this.user.email = user.email;
        } else {
          this.startFBUI();
          this.user.email = null;
        }
        this.user.uid = user.uid;
        this.showLoginModal = false;

        this.$rtdbBind('settings', db.ref('users/' + this.user.uid + '/settings')).then(() => {
          // cb after bind
          if (this.settings && !user.isAnonymous && !this.settings.isRegistered){
            this.savesettings({isRegistered: true})
            sendRegistrationEmail(this.user.email)
            reportEvent('createAccount', {'email': this.user.email})
            this.$analytics.fbq.event('CompleteRegistration')
            this.$gtag.event('conversion', {
              'send_to': 'AW-311471832/mQ27CImxlPACENjdwpQB'
            })
          }
          if (this.settings && this.settings.premiumEnd) {
            getTimeStamp((newTS) => {
              const today = new Date(newTS)
              if (today > this.settings.premiumEnd) {
                if(this.settings.customer){
                  fetch(`${API_HOST}/api/subscriptions?customerId=${this.settings.customer.id}${this.testPayment ? '&test=1' : ''}`, {}).then((response) => {
                    return response.json();
                  }).then((data) => {
                    let subscriptions = data.subscriptions.data
                    subscriptions.forEach((item) => {
                      if(item.status == 'active'){
                        this.settings.premiumEnd = item.current_period_end * 1000
                      }
                    })
                    if(today > this.settings.premiumEnd){
                      this.savesettings({isPremium: false, premiumEnd: null, theme: defaultUserSettings.theme,
                        autoLock: defaultUserSettings.autoLock, dailyLimit: defaultUserSettings.dailyLimit,
                        alwaysTop: defaultUserSettings.alwaysTop, todayDailyLimit: defaultUserSettings.todayDailyLimit,
                        dailyLimitUsed: 0, availableTime: defaultUserSettings.availableTime})
                      alert('Your Premium Plan just ended')
                    } else {
                      this.savesettings({isPremium: true, premiumEnd: this.settings.premiumEnd})
                    }
                  })
                }
              }
            })
          }
          if ((this.settings && this.settings.isPremium) || (localStorage.getItem('isRemote') === 'false')) {
            console.log(this.settings, this.settings.isPremium, localStorage.getItem('isRemote'));
            const tag = getCookie('tag');
            if (tag) {
              this.$OneSignal.sendTag('user_tag', tag);
            }
            this.$OneSignal.sendTag('user_is_premium', this.settings.isPremium);

            this.$OneSignal.showSlidedownPrompt();
          }

        })
        this.$rtdbBind('statistic', db.ref('users/' + this.user.uid + '/statistic')).then(() => {
          // cb after bind
        })
      }
    },
    closeMobileMenu () {
      this.mobileOpen = false
    },
    startFBUI () {
      const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
      const $this = this;
      ui.start('#firebaseui-auth-container', {
        signInOptions: [
          {
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            requireDisplayName: false,
          }
        ],
        autoUpgradeAnonymousUsers: true,
        signInFlow: 'popup',
        callbacks: {
          signInSuccessWithAuthResult(authResult) {
            $this.showLoginModal = false;
            $this.updateUserInfo(authResult.user);
            connectToExtension(authResult.user.uid, true);
            if (authResult.additionalUserInfo.isNewUser) {
              reportEvent('createAccount', {'email': authResult.user.email})
              $this.$analytics.fbq.event('CompleteRegistration')
              this.$gtag.event('conversion', {
                'send_to': 'AW-311471832/mQ27CImxlPACENjdwpQB'
              })
              sendRegistrationEmail(authResult.user.email)
            } else {
              reportEvent('userSignIn', {'userID': authResult.user.uid, 'isAnonymous': false, 'email': authResult.user.email})
            }
            return false;
          },
          signInFailure(error) {
            // For merge conflicts, the error.code will be
            // 'firebaseui/anonymous-upgrade-merge-conflict'.
            if (error.code !== 'firebaseui/anonymous-upgrade-merge-conflict') {
              return Promise.resolve();
            }
            // The credential the user tried to sign in with.
            var cred = error.credential;
            // Copy data from anonymous user to permanent user and delete anonymous
            // user.
            // ...
            // Finish sign-in after data is copied.
            return firebase.auth().signInWithCredential(cred);
          },
        },
      });
    },
    clickBanner () {
      this.showOnlyPremiumModal = true
      reportEvent('clickPremiumBanner', {'bannerPosition': 'header', 'isRemote': localStorage.getItem('isRemote')})
    }
  },
  components: {
    Feedback,
    Help,
    PremiumPurchasedModal,
    Subscription,
    GetPremiumModal, PremiumModal, GetPremiumModalAndroid,
    Menu, Settings, Sites, Remote, Statistics, Backgrounds, Premium
  },
  mounted() {
    reportEvent('dashboard_load')
    const urlQuery = this.$router.currentRoute.query
    this.showPremiumIsPurchased = !!urlQuery.showbuypremium
    this.newUserLogged = !!urlQuery.newuser
    // this.$router.push(this.$route.path)

    // TODO move to other method
    const { currentUser } = firebase.auth();
    this.updateUserInfo(currentUser)

    this.unsubscribeFB = firebase.auth().onAuthStateChanged((user) => {
      console.log(user);
      this.updateUserInfo(user);
    });

    if(window.matchMedia('(max-width: 1200px)').matches) {
      this.sidebar = 'narrow'
    }
  },
  destroyed() {
    if (this.unsubscribeFB) {
      this.unsubscribeFB();
    }
  },
  watch: {
    settings(newSettings) {
      if (newSettings && newSettings.isPremium && this.showGetPremiumAndroid) {
        this.showGetPremiumAndroid = false;
        this.showPremiumIsPurchased = true;
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/styles/base.module";
</style>
